import React, { useEffect } from "react";

import { FormField, useSignupFormDrip } from "@sp-state/useSignupFormDrip";
import { useFormData } from "@sp-state/useFormData";
import AgreementInput from "@components/shared/Inputs/AgreementInput";
import EmailInput from "@components/shared/Inputs/EmailInput";
import FirstNameInput from "@components/shared/Inputs/FirstNameInput";
import LastNameInput from "@components/shared/Inputs/LastNameInput";
import PasswordInput from "@components/shared/Inputs/PasswordInput";
import PhoneInput from "@components/shared/Inputs/PhoneInput";
import ProfessionsInput from "@components/shared/Inputs/ProfessionsInput";
import QuestionInput from "@components/shared/Inputs/QuestionInput";
import OfferInput from "@components/shared/Inputs/OfferInput";

type FormFieldsType = {
  fields: FormField[] | undefined;
};

const FormFields: React.FC<FormFieldsType> = ({ fields }) => {
  const { setAllowNext } = useSignupFormDrip(state => state);
  const formData = useFormData();

  useEffect(() => {
    if (fields) setAllowNext();
  }, [formData, fields, setAllowNext]);

  const fieldsOpts = {
    agreement: AgreementInput,
    email: EmailInput,
    firstName: FirstNameInput,
    lastName: LastNameInput,
    password: PasswordInput,
    phone: PhoneInput,
    profession: ProfessionsInput,
    questions: QuestionInput,
    offer: OfferInput,
  };

  const fieldsList =
    fields &&
    fields.map(item => {
      const Field = fieldsOpts[item?.field];

      return (
        <>
          <Field
            key={item?.field}
            questionAttributes={
              item?.field === "questions" && item.questionAttributes
                ? item.questionAttributes
                : null
            }
            offerOne={item?.offerAttributesOne}
            offerTwo={item?.offerAttributesTwo}
            defaultOfferOne={item?.defaultOfferOne}
          />
        </>
      );
    });

  return <>{fieldsList}</>;
};

export default FormFields;
